import {formatDate} from '../../../helpers/utils';

export const COMMON_REQ = 'cris/inspection/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/inspection/COMMON_REQ_FAIL';

export const LOAD_INSPECTION_WORK_ORDERS_SUCCESS = 'cris/inspection/LOAD_INSPECTION_WORK_ORDERS_SUCCESS';
export const LOAD_SEARCHED_INSPECTION_WORK_ORDERS_SUCCESS = 'cris/inspection/LOAD_SEARCHED_INSPECTION_WORK_ORDERS_SUCCESS';

const initialState = {
	isLoading: false,
	isSearched: false,
	error: null,
	workOrders: [],
	searchedWorkOrders: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_INSPECTION_WORK_ORDERS_SUCCESS:
			const workOrders = action.payload.data.work_orders.map((item) => ({
				id: item.id,
				code: item.code,
				revision: item.revision,
				prr_ncn: item.prr_ncn || '',
				job_description: item.job_description,
				start_date: item.start_date,
				formattedStartDate: formatDate(item.start_date),
				clients_information: item.clients_information || '',
				old_code: item.old_code || '',
				customerName: item.customer ? item.customer.name : '',
				jobLocationName: item.job_location ? item.job_location.name : ''
			}));

			return {
				...state,
				isLoading: false,
				workOrders: workOrders
			};

		case LOAD_SEARCHED_INSPECTION_WORK_ORDERS_SUCCESS:
			const searchedWorkOrders = action.payload.data.work_orders.map((item) => ({
				id: item.id,
				code: item.code,
				revision: item.revision,
				prr_ncn: item.prr_ncn || '',
				job_description: item.job_description,
				start_date: item.start_date,
				formattedStartDate: formatDate(item.start_date),
				clients_information: item.clients_information || '',
				old_code: item.old_code || '',
				customerName: item.customer ? item.customer.name : '',
				jobLocationName: item.job_location ? item.job_location.name : ''
			}));

			return {
				...state,
				isLoading: false,
				isSearched: true,
				searchedWorkOrders: searchedWorkOrders
			};

		default:
			return state;
	}
}